import React, { useEffect, useState } from 'react';
import { css } from '@compiled/react';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { useNavigate } from 'react-router-dom';

import { getAssetUrl } from 'src/services/http/user';
import { AllLearningPathsSection } from 'src/pages/HomePage/children/AllLearningPathsSection';
import { ENABLEMENT_ACADEMY_IN_ALP_FF } from 'src/constants';
import { fetchAdobeAccountId } from 'src/services/http/adobeAuth';

import { ContentSection } from './children/ContentSection';

export const HIGHLIGHTED_CATALOGS_DATA = [
  {
    title: 'Get Accredited',
    assetURL: '/images/homePage/getStartedQuickly.png',
    altText: 'Get started quickly image',
    url: '/enable/hub/get-accredited',
  },
  {
    title: 'Maintain Your Accreditation',
    assetURL: '/images/homePage/boostProductivity.png',
    altText: 'Boost productivity and teamwork image',
    url: '/enable/hub/maintain-your-accreditation',
  },
];

export enum CatalogIds {
  NEW_TRAINING = '198657',
  PRODUCTS_AND_SOLUTIONS = '200742',
  ROLE_BASED_TRAINING = '200845',
}

export const EnablementHomePage: React.FC = () => {
  const navigate = useNavigate();
  const [adobeAccountId, setAdobeAccountId] = useState<string | null>(null);

  const enablementAcademyEnabled = FeatureGates.checkGate(ENABLEMENT_ACADEMY_IN_ALP_FF);

  useEffect(() => {
    // eslint-disable-next-line no-console
    fetchAdobeAccountId().then(setAdobeAccountId).catch(console.error);
  }, []);

  if (!enablementAcademyEnabled) {
    navigate('/');

    return null;
  }

  return (
    <div css={homePageContainerStyles}>
      <img
        src={getAssetUrl('/images/enablement/EA-home-page-header-template-fall25-001.jpeg')}
        alt="enablement banner"
        css={imageStyles}
      />
      <AllLearningPathsSection
        cardsData={HIGHLIGHTED_CATALOGS_DATA}
        gridColumns={2}
        backgroundColor="#F8F8F8"
        showHeader={false}
      />
      <div css={sectionWrapperStyles}>
        <div css={contentSectionStyles}>
          <ContentSection title="New Training" catalogId={CatalogIds.NEW_TRAINING} adobeAccountId={adobeAccountId} />
        </div>
      </div>
      <div css={sectionWrapperStyles}>
        <div css={contentSectionStyles}>
          <ContentSection
            title="Products & Solutions"
            catalogId={CatalogIds.PRODUCTS_AND_SOLUTIONS}
            adobeAccountId={adobeAccountId}
          />
        </div>
      </div>
      <div css={sectionWrapperStyles}>
        <div css={contentSectionStyles}>
          <ContentSection
            title="Role Based Training"
            catalogId={CatalogIds.ROLE_BASED_TRAINING}
            adobeAccountId={adobeAccountId}
          />
        </div>
      </div>
    </div>
  );
};

const homePageContainerStyles = css({
  width: '100%',
  marginTop: '136px',

  '@media (max-width: 1279px)': {
    marginTop: '0',
  },
});

const contentSectionStyles = css({
  maxWidth: '1022px',
  width: '100%',
  margin: '0 auto',
  padding: '0 24px',
});

const imageStyles = css({
  width: '100%',
  height: 'auto',
  display: 'block',
});

const sectionWrapperStyles = css({
  width: '100%',
  padding: '40px 0',

  '&:nth-child(odd)': {
    backgroundColor: '#FFFFFF',
  },

  '&:nth-child(even)': {
    backgroundColor: '#F8F8F8',
  },
});
